import { render, staticRenderFns } from "./AnimalHealth.vue?vue&type=template&id=7b291a21&"
import script from "./AnimalHealth.vue?vue&type=script&lang=js&"
export * from "./AnimalHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports